import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { createEnum } from "@/lib/utils/createEnum";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";
import { ExternalLink } from "@/components/ExternalLink";

export type S1MonthlyComments = {
  id: number;
  strategy_id: number;
  strategy_name: string;
  comment?: string;
  created_at: string;
  updated_at: string;
  date: string;
  comment_type?: string;
};
export const s1MonthlyCommentsFields = createEnum<S1MonthlyComments>();

const t = (key: string) =>
  i18n.t(`${Tables.S1_MONTHLY_COMMENTS}.columns.${key}`, { ns: "tables" });

export const s1_monthly_comments_columns: ColumnDef<S1MonthlyComments>[] = [
  {
    accessorKey: s1MonthlyCommentsFields.id,
    header: () => t("id"),
  },
  {
    accessorKey: s1MonthlyCommentsFields.date,
    header: () => t("date"),
  },
  {
    accessorKey: s1MonthlyCommentsFields.strategy_name,
    header: () => t("strategy_name"),
    cell: ({ row }) => {
      return (
        <ExternalLink
          href={toWorkspacePath(
            `/admin/${Clients.QTL_REFERENTIAL}/${Tables.STRATEGIES}/${row.original.strategy_id}`,
          )}
          className="text-xs"
          underline="hover"
        >
          {row.original.strategy_name}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: s1MonthlyCommentsFields.comment_type,
    header: () => t("comment_type"),
  },
  {
    accessorKey: s1MonthlyCommentsFields.comment,
    header: () => t("comment"),
    cell: ({ row }) => (
      <div className="line-clamp-5 max-w-lg whitespace-pre-wrap text-xs leading-5">
        {row.original.comment}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue(s1MonthlyCommentsFields.id)}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
